import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ListaEmpresasService {
  public datosCompartidos: string = '';
  public grupoEmpresas:any[] = [];
  public rutEmprSel: string;
  public rznSocialEmprSel: string;

  constructor() { }

  guardarEmpresas(grupoEmpresas:any[]): void {
    this.grupoEmpresas = grupoEmpresas;
  }

  obtenerEmpresas(): any[] {
    return this.grupoEmpresas;
  }

  seleccionarEmpresa(rutEmprSel: string,rznSocialEmprSel: string): void{
    this.rutEmprSel = rutEmprSel;
    this.rznSocialEmprSel = rznSocialEmprSel;
  }

  obtenerEmpresaSel(): string {
    return this.rutEmprSel;
  }

  obtenerEmpresaSelDsc(): string {
    return this.rznSocialEmprSel;
  }

  guardarDatos(datos: string): void {
    this.datosCompartidos = datos;
  }

  obtenerDatos(): string {
    return this.datosCompartidos;
  }

  limpiarDatos(): void {
    this.rznSocialEmprSel = '';
    this.grupoEmpresas = [];
    this.datosCompartidos = '';
    this.rutEmprSel = '';
  }
}
